import React from "react";
import { useParams } from "react-router-dom";
import { ChatContainer } from "@/components/chat/ChatContainer";
import { ProfileHeader } from "@/components/player/profile/ProfileHeader";

const PlayerChat = () => {
  const { conversationId } = useParams<{ conversationId?: string }>();

  return (
    <div className="p-8 max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white">Chat</h1>
        <p className="text-gray-400 mt-1">
          Converse com seus mentores
        </p>
      </div>
      
      <div className="h-[calc(100vh-280px)] min-h-[600px] overflow-hidden border border-[#00B6F0] rounded-lg">
        <ChatContainer initialConversationId={conversationId} />
      </div>
    </div>
  );
};

export default PlayerChat;
